'use client';

import { type UserLocaleCode } from '@ifixit/i18n/user-locale';
import { userLocaleFromCountryCode } from '@ifixit/i18n/geo-user-locale';
import { useCookieState } from './use-cookie-state';
import { useMemo } from 'react';

/**
 * Detects the user's locale from geo headers (via middleware cookie) and
 * browser language preferences. Returns null when the country is unknown.
 */
export function useDetectedUserLocale(): UserLocaleCode | null {
   const [countryCode] = useCookieState('detected-country');

   return useMemo(() => userLocaleFromCountryCode(countryCode, browserLanguages()), [countryCode]);
}

function browserLanguages(): readonly string[] {
   return typeof navigator === 'undefined' ? [] : navigator.languages;
}
